import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	openIssueLinkLabel: {
		id: 'polaris-common.issue-card.open-issue-link-label',
		defaultMessage: 'Open',
		description: 'Label for button to issue',
	},
});
